export default function ProjectsListModal({ projects, callback, className }) {
    projects = Object.values(Object.groupBy(projects, ({Year})=>Year)).sort((a,b)=>(b[0].Year-a[0].Year));
    
    return (
        <div className={"inspect-projects-modal"+className}>
            <button className="inspect-projects-modal-close" onClick={callback} autoFocus>&times;</button>
            {projects.map(year => (
                <div key={year[0].Year} className="inspect-projects-modal-year">
                    <span key={year[0].Year}>{year[0].Year}</span>
                    {year.map(project => (
                        <a key={year[0].year+project.ProjectName} onClick={callback} href={"#"+project.ProjectID}>{project.ProjectName}</a>
                    ))}
                </div>
            ))}
        </div>
    )
}